import { render } from "./KanbanComponent.vue?vue&type=template&id=92c3224a&scoped=true"
import script from "./KanbanComponent.vue?vue&type=script&lang=js"
export * from "./KanbanComponent.vue?vue&type=script&lang=js"

import "./KanbanComponent.vue?vue&type=style&index=0&id=92c3224a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92c3224a"]])

export default __exports__